import { ReactNode } from 'react';

import { Box } from '@material-ui/core';

interface TabPanelProps {
  children?: ReactNode;
  value: string | number;
  index: string | number;
  className?: string;
  paddingTop?: number;
}

export default function TabPanel(props: TabPanelProps) {
  const { children, value, index, className, paddingTop = 2, ...rest } = props;

  return (
    <Box
      height="100%"
      overflow="hidden"
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...rest}
    >
      {value === index && (
        <Box
          height="100%"
          pt={className ? 0 : paddingTop}
          className={className}
        >
          {children}
        </Box>
      )}
    </Box>
  );
}
